export class Pic2Card {
	static pic2cardService = "";
	static privacyLink = "../privacy";
}
